import script from "./STDSDC05C07LoginSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC05C07LoginSecurity.vue?vue&type=script&setup=true&lang=js"

import "./STDSDC05C07LoginSecurity.vue?vue&type=style&index=0&id=266ea604&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266ea604"]])

export default __exports__